export enum HttpErrorCode {
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
}

export { ServerErrorCode } from 'APP/restApi/constants/constants';
